
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
const PlanItem = ({ plan, data }) => {
    return <li className={`plans_item`}>
        <div className={`plans_item_wrapper ${plan.key}`}>
            <h3 className={'plans_item_title'}>{data.title} {plan.title}</h3>
            <p className={'plans_item_price'}><span className={'value'}>{plan.price}</span>/{data.price}</p>
            <img width={28} height={28} src={`/img/pages/ecosystem/cold_dvpn/features/plan_${plan.key}_icon.png`} alt={`Coldware VPN ${data.title} ${plan.title}`}/>
            <p className={'plans_item_nodes'}>{plan.nodes} {data.nodes}</p>
            <p className={'plans_item_size'}>{plan.size}</p>
            <div className={'plans_item_arrow'}>
                <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 12L-4.32134e-07 12" stroke="white" strokeWidth="2" strokeMiterlimit="10"/>
                    <path d="M8 23L19 12L8 1" stroke="white" strokeWidth="2" strokeMiterlimit="10"/>
                </svg>
            </div>
        </div>
    </li>;
};
const Features = ({ t }) => {
    const features = t('coldware_dvpn:features', {}, { returnObjects: true });
    const plans = [
        {
            "key": "a",
            "title": "A",
            "price": "$5",
            "nodes": "50",
            "size": "50GB"
        }, {
            "key": "b",
            "title": "B",
            "price": "$10",
            "nodes": "500",
            "size": "100GB"
        }, {
            "key": "c",
            "title": "C",
            "price": "$20",
            "nodes": "2000",
            "size": "200GB"
        }
    ];
    return (<section className={'features'}>
            <div className="container">
                <div className="features_wrapper">
                    <h2 className={'features_title'}>{features.label}</h2>
                    <div className="features_block">
                        <div className={'features_block_title'}>
                            <h3>{features.block_1.title}</h3>
                        </div>
                        <div className={'features_block_description'}>
                            <p className={'features_block_description_text'} style={{ margin: 0 }}>{features.block_1.description}</p>
                        </div>
                    </div>
                    <div className="features_block">
                        <div className={'features_block_title'}>
                            <h3>{features.block_2.title}</h3>
                        </div>
                        <div className={'features_block_description'}>
                            <p className={'features_block_description_text'}>{features.block_2.description}</p>
                            <ul className={'plans'}>
                                {plans.map(plan => {
            return <PlanItem key={plan.key} plan={plan} data={features.plans}/>;
        })}
                            </ul>
                        </div>
                    </div>
                    <div className="features_block">
                        <div className={'features_block_title'}>
                            <h3>{features.block_3.title}</h3>
                        </div>
                        <div className={'features_block_description'}>
                            <p className={'features_block_description_text'}>{features.block_3.description}</p>
                            <picture>
                                <source media="(max-width: 767px)" srcSet={`/img/pages/ecosystem/cold_dvpn/features/nodes_small.webp`} type="image/webp"/>
                                <source media="(min-width: 768px)" srcSet={`/img/pages/ecosystem/cold_dvpn/features/nodes.webp`} type="image/webp"/>
                                <source media="(max-width: 767px)" srcSet={`/img/pages/ecosystem/cold_dvpn/features/nodes_small.png`}/>
                                <source media="(min-width: 768px)" srcSet={`/img/pages/ecosystem/cold_dvpn/features/nodes.png`}/>
                                <img src={`/img/pages/ecosystem/cold_dvpn/features/nodes.png`} alt={`ColdWare Wallet`} width={620} height={749} className='description_img'/>
                            </picture>
                        </div>
                    </div>
                </div>
            </div>
        </section>);
};
export default Features;

    async function __Next_Translate__getStaticProps__196111db54b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//ecosystem/dvpn/Features/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196111db54b__ as getStaticProps }
  